import React from "react";
import Menu from "../components/Menu";
import Header from "../components/Header";
import { Prices } from "../components/Prices";
import { FAQs } from "../components/FAQs";
import { Contact } from "../components/Contact";
import Footer from "../components/Footer";
import { Timeline } from "../components/Timeline";
import { Teachers } from "../components/Teachers";
import { MainScreen } from "../components/MainScreen";
import { DesiredLife } from "../components/DesiredLife";
import { NoExperience } from "../components/NoExperience";
import { Curricula } from "../components/Curricula";
import { AcademicPlan } from "../components/AcademicPlan";
import { NotAlone } from "../components/NotAlone";
import { AI } from "../components/AI";
import { Testimonials } from "../components/Testimonials";
import { Companies } from "../components/Companies";

const Home = () => {
  return (
    <>
      <Menu />
      <MainScreen />
      <DesiredLife />
      <Companies />
      <NoExperience />
      <Curricula />
      <AcademicPlan />
      <NotAlone />
      <AI />
      <Teachers />
      <Testimonials />
      <Prices />
      <FAQs />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
